module.exports = __webpack_public_path__ + "img/maple.be5030ca.webp";